import { useMutation } from '@tanstack/react-query'
import api from '../api'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'

export const useDeleteLogin = () => {
  return useMutation(() => api.delete(ApiRouteEnum.LOGIN))
}
